<template>
  <div class="vg-content">
    <van-image class="logo" width="110" height="110" :src="srcExpired"/>
    <div class="title">登录已过期</div>
    <div class="text">请前往猎豹TP端重新登录</div>
  </div>
</template>

<script>
import {Image as VanImage} from "vant";
import srcExpired from "@/assets/login/login_expired.svg";

export default {
  name: "LoginExpired",
  components: {
    VanImage,
  },
  data() {
    return {
      srcExpired: srcExpired,
    }
  }
}
</script>

<style scoped>
.vg-content {
  /*background-color: #FFFFFF;*/
  padding: 30px 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

.logo {
  margin-top: 110px;
}

.title {
  margin-top: 1px;
  color: #4BA9F6;
  font-size: 20px;
}

.text {
  margin-top: 60px;
  color: #000000;
  font-size: 20px;
}
</style>